const DEVICE_ID_STORAGE_KEY = 'pmp_device_id';

export const getOrCreateDeviceId = (): string => {
  const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (existing) {
    return existing;
  }
  const fresh = crypto.randomUUID();
  localStorage.setItem(DEVICE_ID_STORAGE_KEY, fresh);
  return fresh;
};
